import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { capitalize } from "@helpers/general";
import { useSnapshot } from "valtio";

import { store, setIsLoading } from "./store";
import { store as dataStore } from "@components/VerticalLayout/store";
import { useFetchGlobal } from "../../../api/hooks";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { editPaymentMethod } from "./hooks";

type ConfirmationModificationMessageType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    idsAssociated: any;
    data: any;
    userData: any;
    setIsAddChoiceClicked: Function;
    setIsEdited: Function;
    isAddChoiceClicked: boolean;
    setDataChoice: Function;
    resetData: Function;
    shopsPaymentMethodsData: any;
    salesSupport: any;
    setIsSendingTag: Function;
    paymentMethod: any;
};

export function ConfirmationModificationMessage({
    isModalOpened,
    setIsModalOpened,
    isAddChoiceClicked,
    data,
    userData,
    setIsAddChoiceClicked,
    setIsEdited,
    idsAssociated,
    setDataChoice,
    resetData,
    shopsPaymentMethodsData,
    salesSupport,
    setIsSendingTag,
    paymentMethod,
}: ConfirmationModificationMessageType) {
    const { salesSupports } = useSnapshot(store);
    const { operatorID } = useSnapshot(dataStore);
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const [isSalesSupportEmpty, setIsSalesSupportEmpty] = useState<boolean[]>(
        []
    );
    const [isDataChanged, setIsDataChanged] = useState<boolean>(false);
    const [canValidate, setCanValidate] = useState<boolean>(false);

    React.useEffect(() => {
        let allPaymentShop: any = [];
        let localSalesSupport: boolean[] = [];
        if (shopsPaymentMethodsData !== undefined) {
            shopsPaymentMethodsData.forEach((el: any) => {
                if (el.subRows !== undefined)
                    el.subRows.forEach((element: any) => {
                        allPaymentShop.push(element.idShop);
                    });
            });
        }

        salesSupports.forEach((el: any) => {
            if (allPaymentShop.includes(el.id)) {
                let filteredSalesSupport: any = el.salesSupport.filter(
                    (value: any) => salesSupport.split(",").includes(value)
                );
                localSalesSupport.push(
                    filteredSalesSupport.length > 0 &&
                        salesSupport.split(",").length ===
                            filteredSalesSupport.length
                );
            }
        });
        setIsSalesSupportEmpty(localSalesSupport);
        let localData: any = Object.values(data)[0];
        setIsDataChanged(
            paymentMethod.Pays !== localData.country ||
                paymentMethod[t("Display name")] !== localData.display ||
                paymentMethod.Tag !== localData.tag
        );
    }, [
        shopsPaymentMethodsData,
        salesSupports,
        salesSupport,
        data,
        isDataChanged,
        paymentMethod,
        t,
    ]);

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => setIsModalOpened(!isModalOpened)}
            >
                <StyledH2>{capitalize(t("Alert"))}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {t(
                        'Do you want to apply these changes for all stores? \n Attention ! If you click on "Validate", the specific settings of the shops will be modified.'
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        editPaymentMethod(
                            ["0"],
                            setCanValidate,
                            userData,
                            operatorID,
                            paymentMethod,
                            isSalesSupportEmpty,
                            isDataChanged,
                            setIsSendingTag,
                            setIsAddChoiceClicked,
                            setIsEdited,
                            setIsModalOpened,
                            setDataChoice,
                            resetData,
                            data,
                            isAddChoiceClicked,
                            isModalOpened,
                            fetchGlobal
                        );
                        setIsAddChoiceClicked(!isAddChoiceClicked);
                        resetData();
                        setIsEdited(false);
                        setIsLoading(false);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    disabled={canValidate}
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        setIsLoading(false);
                        setIsModalOpened(!isModalOpened);
                        editPaymentMethod(
                            idsAssociated,
                            setCanValidate,
                            userData,
                            operatorID,
                            paymentMethod,
                            isSalesSupportEmpty,
                            isDataChanged,
                            setIsSendingTag,
                            setIsAddChoiceClicked,
                            setIsEdited,
                            setIsModalOpened,
                            setDataChoice,
                            resetData,
                            data,
                            isAddChoiceClicked,
                            isModalOpened,
                            fetchGlobal
                        );
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
